<template>
  <div
    ref="container"
    class="lh-article-card-meta"
    :style="{ '--base-color': color, '--hover-color': hoverColor }"
  >
    <span
      v-if="isPromo"
      ref="category"
      class="lh-article-card-meta__promo lh-article-card-meta__text"
      data-jest="promo"
    >
      {{ partnerText }}
    </span>
    <span
      v-else-if="isAdvertising"
      ref="category"
      class="lh-article-card-meta__partner lh-article-card-meta__text"
      data-jest="partner"
    >
      {{ partnerText }}
    </span>
    <div
      v-else
      class="lh-article-card-meta__container"
    >
      <div class="lh-article-card-meta__text">
        <time
          v-show="dateText && dateVisible && isDateShowArticleCardSmall()"
          ref="date"
          class="lh-article-card-meta__date"
          data-jest="date"
          :datetime="dateMoscow"
        >
          {{ dateText }}
        </time>
      </div>
      <div
        v-for="(categoryItem, index) of computedCategories"
        :key="index"
        class="lh-article-card-meta__text"
      >
        <span
          v-if="isCircularLink(categoryItem) && !disableBreadcrumbCircularLink"
          ref="category"
          class="lh-article-card-meta__category"
        >
          {{ categoryItem.title }}
        </span>
        <span v-else>
          <TheLinkUi
            ref="category"
            class="lh-article-card-meta__category lh-article-card-meta__text"
            data-jest="category"
            :href="removeLifehackerFromUrl(categoryItem.url)"
            @click="
              $emit(
                'clicked-on-category',
                removeLifehackerFromUrl(categoryItem.url),
                categoryItem.title,
              )
            "
          >
            {{ categoryItem.title }}
          </TheLinkUi>
        </span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
  import type { PropType } from 'vue';

  import TheLinkUi from '@/components/lh-ui/TheLinkUi/TheLink.vue';
  import { removeLifehackerFromUrl } from '~/utils/removeLifehackerFromUrl';

  const CATEGORIES_COUNT = 2;

  export default defineNuxtComponent({
    name: 'ArticleCardMeta',
    components: {
      TheLinkUi,
    },

    inject: {
      isDateShowArticleCardSmall: {
        default() {
          return () => true;
        },
      },
    },

    props: {
      disableBreadcrumbCircularLink: {
        type: Boolean,
        default: false,
      },
      dateText: {
        type: String as PropType<string>,
        required: false,
        default: '',
      },
      dateMoscow: {
        type: String,
        required: true,
      },
      isPromo: {
        type: Boolean as PropType<boolean>,
        required: false,
        default: false,
      },
      isAdvertising: {
        type: Boolean as PropType<boolean>,
        required: false,
        default: false,
      },
      categories: {
        type: Array as PropType<Array<IArticleCategory>>,
        required: false,
        default: () => [],
      },
      categoriesCount: {
        type: Number as PropType<number>,
        required: false,
        default: CATEGORIES_COUNT,
      },
      color: {
        type: String as PropType<string>,
        required: false,
        default: '#5C5C5C',
      },
      hoverColor: {
        type: String as PropType<string>,
        required: false,
        default: 'black',
      },
      tags: {
        type: Array as PropType<Array<IArticleTags>>,
        required: false,
        default: () => [],
      },
      type: {
        type: String as PropType<string>,
        default: '',
      },
      partnerText: {
        type: String as PropType<string>,
        default: '',
      },
    },
    data() {
      return {
        container: {} as HTMLElement,
      };
    },
    computed: {
      isAds(): boolean {
        return this.isAdvertising || this.isPromo;
      },
      dateVisible(): boolean {
        return Boolean(this.dateText) && !this.isAds;
      },
      computedCategories(): IArticleCategory[] {
        // Отображать категории в том порядке, в котором приходит с бэка
        const breadCrumbs = this.categories.length ? this.categories : this.tags;
        return breadCrumbs.slice(0, this.categoriesCount);
      },
    },
    mounted() {
      this.container = this.$refs.container as HTMLElement;
    },
    methods: {
      removeLifehackerFromUrl,

      isCircularLink(categoryItem: IArticleCategory): boolean {
        // @ts-ignore
        const path = this.$route?.path || '';

        return path.includes(categoryItem.url);
      },
    },
  });
</script>

<style lang="scss" scoped>
  .lh-article-card-meta {
    @include fontSmallText;
    position: relative;

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;

    overflow: hidden;

    .lh-article-card-meta__hide {
      opacity: 0;
      z-index: 0;
    }
  }

  .lh-article-card-meta__promo,
  .lh-article-card-meta__partner,
  .lh-article-card-meta__date {
    color: var(--base-color);
  }

  .lh-article-card-meta__date {
    white-space: nowrap;
  }

  .lh-article-card-meta__category,
  .lh-article-card-meta__author {
    color: var(--base-color);
    text-decoration: none;
  }

  a.lh-article-card-meta__category,
  a.lh-article-card-meta__author {
    cursor: pointer;

    @include hover {
      color: var(--hover-color);

      &:after {
        color: var(--base-color);
      }
    }
  }

  .lh-article-card-meta__container {
    display: flex;
    flex-wrap: wrap;
    word-break: break-word;

    .lh-article-card-meta__text {
      margin-right: 6px;
    }

    .lh-article-card-meta__text + .lh-article-card-meta__text::before {
      color: var(--base-color);
      content: '/';
      margin-right: 6px;
    }
  }
</style>
